var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const devices = [
    {
        type: 'decoder',
        modelId: '-NU2FVxso3ZqLjpSmXqj',
        modelName: 'D4100',
    },
    {
        type: 'decoder',
        modelId: '-NU2Fe2VnsmFGFlCahAF',
        modelName: 'D4200',
    },
    {
        type: 'decoder',
        modelId: '-NU2FiYWpJ0zu4J2dAi3',
        modelName: 'DuetD',
    },
    {
        type: 'decoder',
        modelId: '-NU2Fp825VSoeAOGv0_R',
        modelName: 'DuetD-2',
    },
    {
        type: 'encoder',
        modelId: '-NU2Fw14dqYv9qB6BXxd',
        modelName: 'DuetE',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2G-fG2IE14LvcFFOp',
        modelName: 'DuetE-2',
        inputs: ['HDMI1', 'HDMI2', 'USB-C'],
        localOutput: 'HDMI',
    },
    {
        type: 'encoder',
        modelId: '-NU2G47q-XAUgAF6NK30',
        modelName: 'DuetE-WP',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2G8TVRo6OVq6yVP1V',
        modelName: 'DuetE-WP-BT',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2GCkAV9TKWuowR8cj',
        modelName: 'DuetE-WP-H',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2GI-OulF6N9VvTac7',
        modelName: 'E-WP',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2GNkJaYdSGsAzrma5',
        modelName: 'E-WP-H',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2GYClhjXUzO0vLfuQ',
        modelName: 'E-WP-BT',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2Gj-GWxpYIevXnOBW',
        modelName: 'E4100',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-NU2Gsv-r6x89SdopJnX',
        modelName: 'E4200',
        inputs: ['HDMI1', 'HDMI2', 'USB-C'],
    },
    // 5-series endpoints
    { type: 'decoder', modelId: '-OLGC4v3oVdMkonikKPo', modelName: 'D5100' },
    { type: 'decoder', modelId: '-OLGC4weVFPE3mNtLlIj', modelName: 'D5200' },
    { type: 'decoder', modelId: '-OLGC4yDNZbAyTMMdyu6', modelName: 'DuetD5' },
    { type: 'encoder', modelId: '-OLGC4znRpPyDMLkVQ6R', modelName: 'DuetE5', inputs: ['HDMI'] },
    { type: 'encoder', modelId: '-OLGC50NHK2iVf4Jy2Va', modelName: 'DuetE5-WP', inputs: ['HDMI'] },
    {
        type: 'encoder',
        modelId: '-OLGC51wcGsQbKpMu-Pd',
        modelName: 'DuetE5-WP-BT',
        inputs: ['HDMI'],
    },
    {
        type: 'encoder',
        modelId: '-OLGC53mMAWVJd2JxIfJ',
        modelName: 'DuetE5-WP-H',
        inputs: ['HDMI'],
    },
    { type: 'encoder', modelId: '-OLGC55LS5Wl6q4jaP5S', modelName: 'E5-WP', inputs: ['HDMI'] },
    { type: 'encoder', modelId: '-OLGC56viIKj4wV-Ya6S', modelName: 'E5-WP-BT', inputs: ['HDMI'] },
    { type: 'encoder', modelId: '-OLGC58UlbYtZVoNeprs', modelName: 'E5-WP-H', inputs: ['HDMI'] },
    { type: 'encoder', modelId: '-OLGC5A3bBOQgdTWFnkG', modelName: 'E5100', inputs: ['HDMI'] },
    {
        type: 'encoder',
        modelId: '-OLGC5BcYIhIitHL6BY2',
        modelName: 'E5200',
        inputs: ['HDMI1', 'HDMI2', 'USB-C'],
    },
];
export class VisionarySolutions {
    constructor(log) {
        this.log = log;
        this.device = devices[0];
        this.firmwareVersion = '3.13.46';
        this.hdmiOut = '';
        this.serialNumber = '';
        this.streamHost = '0.0.0.0';
        this.streamVideo = '';
        this.videoOutput = 'LOGO';
        this.asyncHandlers = [
            {
                method: 'post',
                path: '/cgi-bin/wapi.cgi',
                callback: (req) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    const params = Object.fromEntries(((_a = req.data) !== null && _a !== void 0 ? _a : '')
                        .trim()
                        .split('&')
                        .filter(s => s.includes('='))
                        .map(s => s.split('=')));
                    // TODO: verify commands start with CMD=START and end with CMD=END?
                    // TODO: verify unit id?
                    if (params['QUERY.KEY'] === 'STREAM.HOST' && this.device.type === 'decoder') {
                        return {
                            data: `&STREAM.HOST=${this.streamHost}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'STREAM.VIDEO' &&
                        this.device.type === 'encoder') {
                        return {
                            data: `&STREAM.VIDEO=${this.streamVideo}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'UNIT.ID') {
                        return {
                            data: `&UNIT.ID=SIMULATED-${this.serialNumber}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'UNIT.MODEL') {
                        return {
                            data: `&UNIT.MODEL=${this.device.modelName}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'UNIT.SERIAL') {
                        return {
                            data: `&UNIT.SERIAL=${this.serialNumber}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'UNIT.FIRMWARE') {
                        return {
                            data: `&UNIT.FIRMWARE=${this.firmwareVersion}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'VIDEO.OUTPUT' &&
                        this.device.type === 'decoder') {
                        return {
                            data: `&VIDEO.OUTPUT=${this.videoOutput}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] !== undefined) {
                        return {
                            data: `&${params['QUERY.KEY']}=NOT_DEFINED&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['UNIT.FU'] !== 'TRUE') {
                        return {
                            data: '&API.STATUS=SUCCESS\n',
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['QUERY.KEY'] === 'VIDEO.HDMI_OUT' &&
                        this.device.type === 'encoder' &&
                        this.device.inputs.length > 0) {
                        return {
                            data: `&VIDEO.HDMI_OUT=${this.hdmiOut}&API.STATUS=SUCCESS_QUERY\n`,
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['STREAM.HOST'] !== undefined &&
                        params['STREAM.CONNECT'] === 'TRUE' &&
                        this.device.type === 'decoder') {
                        this.streamHost = params['STREAM.HOST'];
                        return {
                            data: '&API.STATUS=SUCCESS\n',
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['STREAM.VIDEO'] !== undefined && this.device.type === 'encoder') {
                        const streamVideo = params['STREAM.VIDEO'];
                        if (this.device.inputs.includes(streamVideo)) {
                            this.streamVideo = streamVideo;
                        }
                        return {
                            data: '&API.STATUS=SUCCESS\n',
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['VIDEO.HDMI_OUT'] !== undefined &&
                        this.device.type === 'encoder') {
                        const hdmiOut = params['VIDEO.HDMI_OUT'];
                        if (this.device.inputs.includes(hdmiOut)) {
                            this.hdmiOut = hdmiOut;
                        }
                        return {
                            data: '&API.STATUS=SUCCESS\n',
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    else if (params['VIDEO.OUTPUT'] !== undefined && this.device.type === 'decoder') {
                        const videoOutput = params['VIDEO.OUTPUT'];
                        if (videoOutput === 'HDMI' || videoOutput === 'LOGO') {
                            this.videoOutput = videoOutput;
                        }
                        return {
                            data: '&API.STATUS=SUCCESS\n',
                            headers: { 'content-type': 'text/plain' },
                            status: 200,
                        };
                    }
                    return {
                        data: '&API.STATUS=SUCCESS_QUERY\n',
                        headers: { 'content-type': 'text/plain' },
                        status: 200,
                    };
                }),
            },
        ];
    }
    onConfigure(config) {
        var _a, _b;
        const device = devices.find(d => d.modelId === config.modelNumber);
        if (device === undefined) {
            this.log.error(`unrecognized modelNumber ${config.modelNumber}`);
        }
        else if (device.modelId !== this.device.modelId) {
            if (this.device.type === 'encoder') {
                this.streamVideo = (_a = this.device.inputs[0]) !== null && _a !== void 0 ? _a : '';
                this.hdmiOut = (_b = this.device.inputs[0]) !== null && _b !== void 0 ? _b : '';
            }
        }
    }
    onInitialize(storage, config) {
        // Generate a serial number in the Visionary Solutions format using the equipmentId. This
        // should provide a unique serial number that is consistent across reboots. We need it to
        // be consistent because it is used in the detected channels. If it wasn't consistent, then
        // any decoder using a simulated encoder would have invalid configured channels each time
        // Mira Connect restarts or reboots.
        var _a, _b;
        const idLength = config.equipmentId.length;
        let serialNumber = '';
        for (let i = 0; i < 12; i++) {
            serialNumber += (config.equipmentId.charCodeAt(idLength - 1 - i) % 10).toString();
            if (i === 2 || i === 5)
                serialNumber += '-';
        }
        this.serialNumber = serialNumber;
        // Figure out our model number and initialize model-specific properties.
        const device = devices.find(d => d.modelId === config.modelNumber);
        if (device === undefined) {
            this.log.error(`unrecognized modelNumber ${config.modelNumber}`);
            this.device = devices[0];
        }
        else {
            this.device = device;
        }
        if (this.device.type === 'encoder') {
            this.streamVideo = (_a = this.device.inputs[0]) !== null && _a !== void 0 ? _a : '';
            this.hdmiOut = (_b = this.device.inputs[0]) !== null && _b !== void 0 ? _b : '';
        }
    }
}
VisionarySolutions.emulatorType = 'httpRequestEmulator';
VisionarySolutions.key = '-NPrrY6eB7EkwX7N30Sj';
